import { inject, Injectable } from '@angular/core';
import { baseUrl } from 'libs/core/src/lib/configs/baseUrl';
import { environment } from 'libs/core/src/lib/environments/environment';
import { IAuthService } from 'libs/core/src/lib/services/auth.service';
import { HttpClient } from '@angular/common/http';
import {
  ILoginRequest,
  ILoginResponse,
  IResetPassword,
  IResetPasswordOtp,
  ISuccessulResponse,
} from '@inshuwa-client/models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InsurerAuthService implements IAuthService {
  private httpClient = inject(HttpClient);

  env = environment;

  login(login: Partial<ILoginRequest>): Observable<ILoginResponse> {
    return this.httpClient.post<ILoginResponse>(
      `${baseUrl()}/auth/insurers/${this.env.insurerId}/login`,
      login,
    );
  }

  requestPasswordResetOtp(
    login: IResetPasswordOtp,
  ): Observable<ISuccessulResponse> {
    return this.httpClient.post<ISuccessulResponse>(
      `${baseUrl()}/auth/password-reset/insurers/${this.env.insurerId}/otp`,
      login,
    );
  }

  resetPassword(login: IResetPassword): Observable<ISuccessulResponse> {
    return this.httpClient.post<ISuccessulResponse>(
      `${baseUrl()}/auth/password-reset/insurers/${this.env.insurerId}`,
      login,
    );
  }
}
